<template>
  <div>
    <div class="ms-auto w-md-auto mt-2">
      <button
        @click="verifyPage()"
        class="btn btn-red claim-identifier"
      >
        Díj újraszámolása
      </button>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['verifyPage']),
  }
};
</script>
